import { feeTemplateService } from "services";
import { FeeTemplatesStatusTypes } from "types";

import { feeTemplateConstants } from "./feeTemplate.constants";

export const feeTemplateActions = {
	add,
	addFeeTemplate,
	edit,
	getFeeTemplate,
	getTemplateById,
	purgeActiveFeeTemplate,
	updateFeeTemplate,
};

function getTemplateById(companyId, templateId) {
	return dispatch => {
		dispatch(request());

		return feeTemplateService.getTemplate(companyId, templateId).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request() {
		return {
			type: feeTemplateConstants.GET_FEE_TEMPLATE_REQUEST,
		};
	}
	function success(template) {
		return {
			type: feeTemplateConstants.GET_FEE_TEMPLATE_SUCCESS,
			template: {
				...template,
				active: FeeTemplatesStatusTypes.getByName(
					template?.active.toString(),
				),
			},
		};
	}
	function failure(error) {
		return {
			type: feeTemplateConstants.GET_FEE_TEMPLATE_ERROR,
			error,
		};
	}
}

function add(companyId, model) {
	return dispatch => {
		return feeTemplateService.add(companyId, model).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function success(add) {
		return {
			type: feeTemplateConstants.ADD_FEE_TEMPLATE_FORM_SUCCESS,
			add,
		};
	}
	function failure(error) {
		return {
			type: feeTemplateConstants.ADD_FEE_TEMPLATE_FORM_ERROR,
			error,
		};
	}
}

function edit(companyId, templateId, model) {
	return dispatch => {
		dispatch(request());

		return feeTemplateService.edit(companyId, templateId, model).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request(add) {
		return {
			type: feeTemplateConstants.EDIT_FEE_TEMPLATE_REQUEST,
			add,
		};
	}
	function success(add) {
		return {
			type: feeTemplateConstants.EDIT_FEE_TEMPLATE_SUCCESS,
			add,
		};
	}
	function failure(error) {
		return {
			type: feeTemplateConstants.EDIT_FEE_TEMPLATE_ERROR,
			error,
		};
	}
}

function getFeeTemplate(companyId, templateId) {
	return dispatch => {
		dispatch(request());

		return feeTemplateService.getFeeTemplate(companyId, templateId).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request() {
		return {
			type: feeTemplateConstants.GET_FEE_TEMPLATE_REQUEST,
		};
	}
	function success(template) {
		return {
			type: feeTemplateConstants.GET_FEE_TEMPLATE_SUCCESS,
			template,
		};
	}
	function failure(error) {
		return {
			type: feeTemplateConstants.GET_FEE_TEMPLATE_ERROR,
			error,
		};
	}
}

function addFeeTemplate(companyId, model) {
	return dispatch => {
		return feeTemplateService.addFeeTemplate(companyId, model).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function success(add) {
		return {
			type: feeTemplateConstants.ADD_FEE_TEMPLATE_FORM_SUCCESS,
			add,
		};
	}
	function failure(error) {
		return {
			type: feeTemplateConstants.ADD_FEE_TEMPLATE_FORM_ERROR,
			error,
		};
	}
}

function updateFeeTemplate(companyId, templateId, model) {
	return dispatch => {
		dispatch(request());

		return feeTemplateService
			.updateFeeTemplate(companyId, templateId, model)
			.then(
				result => {
					dispatch(success(result));
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request(add) {
		return {
			type: feeTemplateConstants.EDIT_FEE_TEMPLATE_REQUEST,
			add,
		};
	}
	function success(add) {
		return {
			type: feeTemplateConstants.EDIT_FEE_TEMPLATE_SUCCESS,
			add,
		};
	}
	function failure(error) {
		return {
			type: feeTemplateConstants.EDIT_FEE_TEMPLATE_ERROR,
			error,
		};
	}
}

function purgeActiveFeeTemplate() {
	return dispatch => {
		dispatch({
			type: feeTemplateConstants.PURGE_ACTIVE_FEE_TEMPLATE,
		});
	};
}
